import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import('./assets/scss/global.scss')

import VScrollLock from 'v-scroll-lock'
import Clipboard from 'v-clipboard'

import modal from '@/components/assets/modal/index.vue'
import VueObserveVisibility from 'vue-observe-visibility'


Vue.use(VScrollLock)
Vue.use(Clipboard)
Vue.use(VueObserveVisibility)

Vue.component('modal', modal)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
